module.exports = __webpack_public_path__ + "img/TZ.ee919c0a.svg";